<template>
  <div id="">
    <div style="margin-top: 20px;">
      <el-form size="small" ref="ruleForm" label-width="200px" :model="ruleForm" :rules="rules" class="demo-ruleForm">
        <el-form-item :label= "$t('message.table.userID')">
          <el-input style="width: 50%;" v-model="userNameVal" type="text" :disabled="userName"></el-input>
        </el-form-item>
        <el-form-item :label= "$t('message.table.newPW')" prop="loginPwd">
          <el-input @keyup.enter.native="submitForm('ruleForm')" style="width: 50%;" v-model="ruleForm.loginPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item :label= "$t('message.table.newPWagain')" prop="loginPwdAgain">
          <el-input @keyup.enter.native="submitForm('ruleForm')" style="width: 50%;" v-model="ruleForm.loginPwdAgain" type="password"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t('message.button.save')}}</el-button>
          <el-button @click="resetForm('ruleForm')">{{$t('message.button.reset')}}</el-button>
          <el-button @click="cancel" type="success">{{ $t("message.button.cancel") }}</el-button>
        </el-form-item>
        
      </el-form>
    </div>
  </div>
</template>

<style scoped>


</style>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        userName: true,
        userNameVal:"",
        ruleForm: {
          loginPwd: '',
          loginPwdAgain:"",
        },
        rules: {
          loginPwd: [
            { required: true, message: this.$t('message.warning.inputPW'), trigger: 'blur' },
            { min: 6, max: 30, message: this.$t('message.warning.PWLength'), trigger: 'blur' }
          ],
          loginPwdAgain: [
            { required: true, message: this.$t('message.warning.inputPW'), trigger: 'blur' },
            { min: 6, max: 30, message: this.$t('message.warning.PWLength'), trigger: 'blur' }
          ],
        }
      }
    },
    mounted() {},
    methods: {
      cancel() {
        this.$router.push("/users");
      },
      loadFormInfo() {
        console.log(this.$store.state.pswUserId);
        this.userNameVal = this.$store.state.pswUserId.name;
      },
      submitForm(formName) {
        var vm = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var session = window.sessionStorage.getItem('userContext');
            session = JSON.parse(session);
            if(vm.ruleForm.loginPwd == vm.ruleForm.loginPwdAgain) {
              //console.log(vm.ruleForm.loginPwd);
              var obj = {
                id:this.$store.state.pswUserId.id,
                loginPwd:vm.ruleForm.loginPwd,
              };
              axios.post('/pmdm/admin/user/resetPwd', obj)
              .then(function (res) {
                //console.log(res);
                if (res.data.code == 200) {
                  vm.open();
                  vm.$router.push("/users");
                } else {
                  vm.$message.error(this.$t('message.error.change'));
                };
              })
              .catch(function (error) {
                console.log(error);
              });
            } else {
              vm.$message.error(this.$t('message.error.notSame'));
            }
            //console.log(session);
            
          } else {
            vm.$message.error(this.$t('message.error.save'));
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      open() {
        this.$message({
          message: this.MessageInfo.s_102,
          type: 'success'
        });
      }
    },
    created() {
      this.loadFormInfo();
    }
  };
</script>